// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"IeKrt81V2fqsj75AA6zyf","errorIcon":"XRpiBhoV9ptIpqpkTIl9m","errorText":"_39GRtrg05VO-74nvLVzyii"};